/**
 * Platform helpers — one-liner OS detection used by the ⌘K / Ctrl K
 * keyboard hint in the navbar (Landing.jsx + SiteHeader.jsx).
 *
 * v60.99.50 — module-level constant so we never re-evaluate on each
 * render AND we avoid the `react-hooks/set-state-in-effect` lint rule
 * (no need for useState + useEffect for a value that's stable for
 * the lifetime of the page). SSR-safe via the `typeof navigator`
 * guard (CRA is client-only today but this protects future-proofs
 * a Next.js migration).
 *
 * The functional shortcut listener in Landing.jsx + SiteHeader.jsx
 * already accepts BOTH `metaKey || ctrlKey` so Ctrl+K on Windows /
 * Linux works regardless of what we display — this util just makes
 * the VISIBLE hint accurate per OS.
 */

const _ua = (typeof navigator !== "undefined")
  ? (navigator.userAgentData?.platform || navigator.platform || navigator.userAgent || "")
  : "";

export const IS_MAC = /mac|ipod|iphone|ipad/i.test(_ua);

/** The "⌘K" / "Ctrl K" label to show in the navbar search-trigger pill. */
export const SEARCH_SHORTCUT_LABEL = IS_MAC ? "⌘K" : "Ctrl K";
